import React from 'react'
import { Box, Typography, Button, TextField, Chip } from '@mui/material'
import { motion } from 'framer-motion'

export default function QuestionDisplay({ question, onAnswer, answered, showResult, correctAnswer }) {
  if (!question) return null

  const isJackpot = question.isJackpot

  return (
    <motion.div
      key={question.order}
      initial={{ opacity: 0, scale: 0.9, rotateY: -15 }}
      animate={{ opacity: 1, scale: 1, rotateY: 0 }}
      exit={{ opacity: 0, scale: 0.9, rotateY: 15 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ textAlign: 'center', p: 2 }}>
        {isJackpot && (
          <Chip label="🎰 JACKPOT x2" color="warning" sx={{ mb: 2, fontSize: '1rem', py: 2 }} />
        )}

        <Typography variant="h4" gutterBottom fontWeight="bold">
          {question.question}
        </Typography>

        {question.media?.url && (
          <Box sx={{ my: 2 }}>
            {question.media.type === 'image' && (
              <img src={question.media.url} alt="" style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }} />
            )}
            {question.media.type === 'audio' && (
              <audio controls src={question.media.url} style={{ width: '100%' }} />
            )}
            {question.media.type === 'video' && (
              <video controls src={question.media.url} style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }} />
            )}
          </Box>
        )}

        {question.type === 'anagram' && (
          <Typography variant="h3" color="secondary" letterSpacing={4} sx={{ my: 3, fontFamily: 'monospace' }}>
            {question.anagramScramble}
          </Typography>
        )}

        {(question.type === 'qcm' || question.type === 'true-false') && question.options && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 3 }}>
            {question.options.map((opt) => {
              const isSelected = answered === opt.id
              const isCorrect = showResult && correctAnswer?.id === opt.id
              const isWrong = showResult && isSelected && !isCorrect

              return (
                <Button
                  key={opt.id}
                  variant={isSelected ? 'contained' : 'outlined'}
                  size="large"
                  disabled={!!answered && !showResult}
                  onClick={() => onAnswer?.(opt.id)}
                  sx={{
                    py: 2,
                    justifyContent: 'flex-start',
                    bgcolor: isCorrect ? 'success.main' : isWrong ? 'error.main' : undefined,
                    color: (isCorrect || isWrong) ? 'white' : undefined,
                    '&:hover': { bgcolor: isCorrect ? 'success.dark' : isWrong ? 'error.dark' : undefined }
                  }}
                >
                  {opt.text}
                </Button>
              )
            })}
          </Box>
        )}

        {(question.type === 'anagram' || question.type === 'quick-answer') && !answered && (
          <QuickAnswerInput onSubmit={onAnswer} />
        )}
      </Box>
    </motion.div>
  )
}

function QuickAnswerInput({ onSubmit }) {
  const [value, setValue] = React.useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (value.trim()) onSubmit?.(value.trim())
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, display: 'flex', gap: 1 }}>
      <TextField
        fullWidth
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Votre réponse..."
        autoFocus
        size="large"
      />
      <Button type="submit" variant="contained" size="large">Envoyer</Button>
    </Box>
  )
}
